import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import Marker from './Marker.jsx';
import {
	MovedOnce,
	InteractedOnce,
	ArrowClicked,
} from '../../utils/Analytics.js';
import {
	getAllSceneInfoDictAsync,
	getSceneIds,
	moldovaMKId
} from '../../utils/StoreConfigManager.js';
import {
	isRoomMarkerClicked,
	addClickedRoomMarker,
} from '../../utils/DynamicStoreDataManager.js';
import ArrowSvg from './ReactSVGArrows/ArrowSvg.jsx';
import StairsUpSvg from './ReactSVGArrows/StairsUpSvg.jsx';
import StairsDownSvg from './ReactSVGArrows/StairsDownSvg.jsx';
import { AppContext } from '../../AppContext.jsx';
import { getWelcomeTooltipRoomId } from '../../utils/StaticAssetManager.js';
import { storeId } from '../../../../variables/Variables.js';

const sceneIdAfterFlateImg = getWelcomeTooltipRoomId();
const isMoldovaMKId = storeId === moldovaMKId;

const CMSTemplateNavSpriteMap = Object.freeze({
	up: ArrowSvg,
	down: ArrowSvg,
	left: ArrowSvg,
	right: ArrowSvg,
	up_left: ArrowSvg,
	down_left: ArrowSvg,
	up_right: ArrowSvg,
	down_right: ArrowSvg,
	stairs_up: StairsUpSvg,
	stairs_down: StairsDownSvg,
});

class NavMarker extends Component {
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);

		const spriteNames = CMSTemplateNavSpriteMap[props.spriteType];

		this.state = {
			svgSprite: spriteNames,
		};

		this.sceneIds = [];
	}

	componentDidMount() {
		getSceneIds()
			.then((sceneIds) => (this.sceneIds = sceneIds))
			.catch((error) => console.error(error));
	}

	onClick() {
		const {
			setLoadingIconVisibility,
			linkedRoomId,
			id,
			threeJSWorldContext,
			setShowWelcomeTooltips,
		} = this.props;
		// setLoadingIconVisibility(true);
		MovedOnce();
		InteractedOnce();

		addClickedRoomMarker(id);

		if (linkedRoomId === sceneIdAfterFlateImg) {
			setShowWelcomeTooltips(true);
		}
		getAllSceneInfoDictAsync()
			.then((sceneInfoDict) => {
				if (!sceneInfoDict[linkedRoomId]) {
					throw new Error(
						'Scene with id ' + linkedRoomId + ' do not exist!',
					);
				}
				const linkedSceneName = sceneInfoDict[linkedRoomId]['name'];
				let targetPath = '/' + linkedSceneName;
				ArrowClicked(linkedSceneName);
				const { controller, history } = threeJSWorldContext;
				history.push(targetPath);
				controller.controller.reset();
			})
			.catch((error) => console.error(error));
	}

	render() {
		const { svgSprite } = this.state;
		return (
			<div>
				<Marker
					transform={this.props.transform}
					colliderTransform={this.props.colliderTransform}
					svgSprite={svgSprite}
					primaryColor={isMoldovaMKId ? '#979797' : this.props.primaryColor}
					secondaryColor={isMoldovaMKId ? '#bdbdbd' : this.props.secondaryColor}
					rotationAngle={this.props.rotationAngle}
					showVisual={this.props.showVisual}
					onClick={this.onClick}
					fade={
						this.props.canFade && isRoomMarkerClicked(this.props.id)
					}
				/>
			</div>
		);
	}
}

NavMarker.propTypes = {
	id: PropTypes.string.isRequired, // '{roomId}-{linkedRoomId}'
	transform: PropTypes.array.isRequired,
	colliderTransform: PropTypes.array.isRequired,
	linkedRoomId: PropTypes.string.isRequired,
	spriteType: PropTypes.string.isRequired,
	canFade: PropTypes.bool.isRequired,
	showVisual: PropTypes.bool,
	setLoadingIconVisibility: PropTypes.func,
	primaryColor: PropTypes.string.isRequired,
	secondaryColor: PropTypes.string.isRequired,
	rotationAngle: PropTypes.number,
};

export default (props) => (
	<AppContext.Consumer>
		{(appContextValue) => (
			<ThreeJSWorldContext.Consumer>
				{(threeJSWorldContext) => (
					<NavMarker
						{...props}
						threeJSWorldContext={threeJSWorldContext}
						setShowWelcomeTooltips={
							appContextValue.setShowWelcomeTooltips
						}
						setLoadingIconVisibility={
							appContextValue.setLoadingIconVisibility
						}
					/>
				)}
			</ThreeJSWorldContext.Consumer>
		)}
	</AppContext.Consumer>
);
